const useCheckEnvironment = () => {
  const currentUrl = window.location.href ? window.location.href : undefined;
  if (currentUrl) {
    const url = new URL(currentUrl);
    const baseURL = `${url.protocol}//${url.host}`;
    switch (baseURL) {
      case "https://admin.finjam.ai":
        return "PROD";
      case "https://uat-admin.finjam.ai":
        return "UAT";
      default:
        return "DEV";
    }
  }
  return false;
};

export default useCheckEnvironment;
